module.exports = __webpack_public_path__ + "static/img/cj11.02a49ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj11.png
// module id = 154
// module chunks = 0